(() => {
  const items = document.querySelectorAll('[data-sas-custom-mega-item]');
  if (!items.length) return;

  const isDesktop = () => window.matchMedia('(min-width: 990px)').matches;

  items.forEach((item) => {
    const trigger = item.querySelector('[data-sas-custom-mega-trigger]');
    const menu = item.querySelector('[data-sas-custom-mega-menu]');
    if (!trigger || !menu) return;

    const setExpanded = (state) => {
      trigger.setAttribute('aria-expanded', state ? 'true' : 'false');
    };

    const openMenu = () => {
      if (!isDesktop()) return;
      setExpanded(true);
    };

    const closeMenu = () => {
      if (!isDesktop()) return;
      setExpanded(false);
    };

    item.addEventListener('mouseenter', openMenu);
    item.addEventListener('mouseleave', closeMenu);
    item.addEventListener('focusin', openMenu);
    item.addEventListener('focusout', (event) => {
      if (item.contains(event.relatedTarget)) return;
      closeMenu();
    });
  });
})();
